module.exports = __webpack_public_path__ + "img/bg.40bb1348.png";